














import { defineComponent } from '@vue/composition-api';
import { GroupRoleRequest } from '@front-app/services/GroupsApi/GroupsMemberApi';
import { Routes } from '@front-app/constants/routes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import DeclineInvitation from '@front-app/components/DeclineInvitation.vue';
import { useGroupMemberStateChange } from '../hooks/useGroupMemberStateChange';

export default defineComponent({
	components: {
		DeclineInvitation,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const {
			status,
			track,
			clear,
		} = useAsyncStatus();
		const memberStateChange = useGroupMemberStateChange();
		const confirmInvitationDecline = async () => {
			await track(memberStateChange.request(props.groupId, GroupRoleRequest.DECLINE));
			ctx.root.$router.push({ name: Routes.GROUPS });
		};
		return {
			status,
			clear,
			confirmInvitationDecline,
		};
	},
});
